import React from 'react'
import OneA_Button_Img from '../images/1A_Button.png'
import TwoA_Button_Img from '../images/2A_Button.png'
import ThreeA_Button_Img from '../images/3A_Button.png'
import FourA_Button_Img from '../images/4A_Button.png'
import B_Button_Img from '../images/B_Button.png'
import Small_Girls_Button_Img from '../images/Small_Girls_Button.png'
import All_State_Button_Img from '../images/all_state_Button.png'
import { Link,useNavigate, useLocation } from 'react-router-dom'

const CenterClassButtons = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const genderSet = location.pathname.split("/");
    const genderId = genderSet[2];


    const renderImages = () => {
        if (genderSet[2] == "g") {
            return (
                <>  
                    <Link to={`/rankings/${genderId}/as/100`}>
                        <img class="classificationImages" src={All_State_Button_Img} alt="All State Girls Rankings Button" />
                    </Link>
                    <Link to={`/rankings/${genderId}/4ag/100`}>
                        <img class="classificationImages" src={FourA_Button_Img} alt="4A Rankings Button" />
                    </Link>
                    <Link to={`/rankings/${genderId}/3ag/100`}>
                        <img class="classificationImages" src={ThreeA_Button_Img} alt="3A Rankings Button" />
                    </Link>
                    <Link to={`/rankings/${genderId}/2ag/100`}>
                        <img class="classificationImages" src={TwoA_Button_Img} alt="2A Rankings Button" />
                    </Link>
                    <Link to={`/rankings/${genderId}/1a1b2bg/100`}>
                        <img class="classificationImages" src={Small_Girls_Button_Img} alt="Small Girls Rankings Button" />
                    </Link>

                </>
            )

        } else if (genderSet[2] == "b") {
            return (
                <>
                    <Link to={`/rankings/${genderId}/as/106`}>
                        <img class="classificationImages" src={All_State_Button_Img} alt="All State Boys Rankings Button" />
                    </Link>
                    <Link to={`/rankings/${genderId}/4ab/106`}>
                        <img class="classificationImages" src={FourA_Button_Img} alt="4A Rankings Button" />
                    </Link>                    
                    <Link to={`/rankings/${genderId}/3ab/106`}>
                        <img class="classificationImages" src={ThreeA_Button_Img} alt="3A Rankings Button" />
                    </Link>                    
                    <Link to={`/rankings/${genderId}/2ab/106`}>
                        <img class="classificationImages" src={TwoA_Button_Img} alt="2A Rankings Button" />
                    </Link>                    
                    <Link to={`/rankings/${genderId}/1ab/106`}>
                        <img class="classificationImages" src={OneA_Button_Img} alt="1A Rankings Button" />
                    </Link>                    
                    <Link to={`/rankings/${genderId}/bb/106`}>
                        <img class="classificationImages" src={B_Button_Img} alt="B Rankings Button" />
                    </Link>                    
                    {/* <Link to={`/rankings/cs`}>
                        <img class="classificationImages" src={B_Button_Img} alt="B Rankings Button" />
                    </Link>                     */}
                </>
            )
        }
    }


  return (
    <div class="classificationButtonsDiv">
        {renderImages()}
    </div>
  )
}
export default CenterClassButtons

